import { api } from './api';

/** Os dois cultos de domingo: 'manha' e o das 10h, 'noite' o das 19h. */
export type Turno = 'manha' | 'noite';
export type TurnoCulto = { chave: Turno; nome: string };
/** `turno` so vem no domingo, quando a equipe serve em um dos cultos so. */
export type EquipeCulto = { id: number; nome: string; turno?: Turno };
export type Demanda = { chave: string; nome: string };
export type CultoDaSemana = { chave: 'arena' | 'fe' | 'domingo'; nome: string; diaSemana: number };

export type EscaladoCulto = {
  id: number;
  membroId: number;
  nome: string;
  funcao: string;
  status: string;
  justificativa: string | null;
};

export type EventoCulto = {
  id: number;
  titulo: string;
  inicio: string | null;
  local: string | null;
  /** so no domingo */
  turno?: Turno;
  escalados: EscaladoCulto[];
  confirmados: number;
  total: number;
};

export type DiaCulto = {
  dia: string;
  culto: { chave: CultoDaSemana['chave']; nome: string };
  demandas: { demanda: string; equipes: EquipeCulto[] }[];
  cultos: EventoCulto[];
};

export type SemContaCulto = { membroId: number; nome: string; papel: 'doze' | 'adm'; equipes: string[] };

export type RespostaCultos = {
  de: string;
  ate: string;
  cultosDaSemana: CultoDaSemana[];
  demandas: Demanda[];
  turnos: TurnoCulto[];
  dias: DiaCulto[];
  ultimoDiaComEscala: string | null;
  equipes: EquipeCulto[];
  semConta: SemContaCulto[];
  podeEditar: boolean;
  meuMembroId: number | null;
};

export const buscarEscalaCultos = (de: string, ate: string, culto: string) =>
  api<RespostaCultos>(`/escala-cultos?de=${de}&ate=${ate}&culto=${encodeURIComponent(culto)}`);

/** Terça e sábado mandam `demandas`; o domingo manda `turnos` (10h e 19h separados). */
export type CorpoDiaCulto =
  | { demandas: Record<string, number[]> }
  | { turnos: Record<Turno, Record<string, number[]>> };

export const salvarDiaCulto = (dia: string, corpo: CorpoDiaCulto) =>
  api<{ sincronia: { cultos: number; entraram: number; sairam: number; semConta: string[] } }>(
    `/escala-cultos/${dia}`,
    { method: 'PUT', body: JSON.stringify(corpo) },
  );

export const sincronizarCultos = () =>
  api<{ dias: number; cultos: number; entraram: number; sairam: number; semConta: string[] }>(
    '/escala-cultos/sincronizar',
    { method: 'POST' },
  );

/** Um instante no meio do dia civil, para reaproveitar os formatadores de data. */
export const meioDoDia = (dia: string) => `${dia}T15:00:00.000Z`;

/** Soma dias a um dia civil "YYYY-MM-DD". */
export function somarDias(dia: string, n: number): string {
  const [a, m, d] = dia.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(a, m - 1, d + n)).toISOString().slice(0, 10);
}

/** "12 da Igreja · Combate: Recepção" -> papel curto e o resto (o que a equipe faz). */
export function lerFuncao(funcao: string): { papel: string; detalhe: string } {
  if (funcao.startsWith('12 da Igreja · ADM')) {
    return { papel: '12 · ADM', detalhe: funcao.slice('12 da Igreja · ADM'.length).replace(/^ · /, '') };
  }
  return { papel: '12 da Igreja', detalhe: funcao.slice('12 da Igreja'.length).replace(/^ · /, '') };
}

/** O que a pessoa responde pelo dia: no domingo sao dois cultos, a resposta e uma so. */
export function statusDoDia(linhas: EscaladoCulto[]): string {
  if (linhas.some((l) => l.status === 'indisponivel')) return 'indisponivel';
  if (linhas.length && linhas.every((l) => l.status === 'confirmado')) return 'confirmado';
  return 'convocado';
}
